<template>
  <div>
    <header v-if="normal_header">
      <div class="contain">
        <img
          @click="$router.push({ path: '/' })"
          class="logo"
          src="@/assets/img/logo.svg"
        />
        <div class="btns right">
          <button @click="$router.push({ path: '/register' })" class="btn">
            Register
          </button>
          <button @click="showLogin()" class="btn text_btn">Login</button>
        </div>
        <img class="profile-icon" src="@/assets/img/user.svg" />
      </div>
    </header>

    <div v-if="!normal_header">
      <header class="admin-header">
        <p>888-317-5531</p>
        <p @click="logout" class="logout">Logout</p>
      </header>

      <div class="sidebar" :class="{ active: show_sidebar }">
        <div
          v-if="show_sidebar"
          class="delete-btn"
          @click="show_sidebar = false"
        >
          <p class="delete">x</p>
        </div>
        <p class="welcome">
          Welcome
          <span>{{ reseller.first_name }} {{ reseller.last_name }}</span>
        </p>
        <div class="navs">
          <div
            v-for="(nav, index) in navs"
            :key="index"
            class="nav"
            :class="{ active: $route.path == nav.url }"
            @click="checkNav(nav)"
          >
            <img :src="require('@/assets/img/' + nav.name + '.svg')" />
            <p>{{ nav.name }}</p>

            <div v-if="show_inner_nav == nav.name" class="inner-navs">
              <p
                v-for="(inner_nav, index) in nav.children"
                @click="checkNav(inner_nav)"
                :key="index"
              >
                {{ inner_nav.name }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!normal_header && !show_sidebar"
      class="mobile-menu-icon"
      @click="show_sidebar = true"
    >
      <img src="@/assets/img/menu.svg" />
    </div>
    <loading></loading>
    <popup></popup>
    <a class='agreement' ref='agreement' href="https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/bundle_kiosk.pdf?alt=media&token=b6187660-2474-4eaf-95e2-62f6fa326934" download></a>
  </div>
</template>

<script>
import Popup from "@/components/Popup";
import Loading from "@/components/Loading";
const fb = require("../firebaseConfig.js");
const db = fb.default.db;
const auth = fb.default.auth;
var moment = require("moment");
var tz = require("moment-timezone");

export default {
  name: "Header",
  components: {
    popup: Popup,
    'loading': Loading
  },
  data() {
    return {
      show_inner_nav: null,
      show_sidebar: false,
      swipe: false,
      showPopup: false,
      status: "submit",
      normal_header: null,
      navs: [
        {
          name: "Dashboard",
          url: "/dashboard",
        },
        {
          name: "Inventory",
          url: "/inventory",
        },
        {
          name: "Purchase Orders",
          url: "/purchaseOrders",
        },
        {
          name: "Client Orders",
          url: "/orders",
        },
        {
          name: "Clients",
          url: "/clients",
        },
        {
          name: "Price List",
          url: "/pricelist",
        },
        {
          name: "Settings",
          children: [
            {
              name: "Agreement",
              url: "/agreement",
            },
            {
              name: "Popshap Assets",
              url: "/assets",
            },
            {
              name: "Profile",
              url: "/profile",
            },
          ],
        },
      ],
    };
  },
  computed: {
    reseller() {
      return this.$store.state.reseller;
    },
    loading(){
      return this.$store.state.loading;
    }
  },
  created() {
    this.checkRoute();
  },
  firestore() {
    return {};
  },
  methods: {
    checkRoute() {
      if (this.$route.name == "Home" || this.$route.name == "Register") {
        this.normal_header = true;
      } else {
        this.normal_header = false;
      }
    },
    logout() {
      return this.$store.dispatch('clearReseller').then(() => {
        return auth.signOut()
      })
      .then(() => {
        this.$router.push("/");
      });
    },
    checkNav(nav) {
      if (nav.children) {
        if (this.show_inner_nav == nav.name) {
          this.show_inner_nav = null;
        } else {
          this.show_inner_nav = nav.name;
        }
      } else {
        if (nav.name === "Agreement") {
          this.downloadAgreement();
        }else {
          this.goTo(nav.url);
        }
      }
    },
    downloadAgreement(){
      window.open('https://firebasestorage.googleapis.com/v0/b/popshap-resellers.appspot.com/o/bundle_kiosk.pdf?alt=media&token=b6187660-2474-4eaf-95e2-62f6fa326934', '_blank');
    }
  },
  watch: {
    $route(to, from) {
      this.checkRoute();
    },
  },
};
</script>

<style lang="scss">
header {
  position: fixed;
  z-index: 10;
  top: 0;
  left: 0;
  padding: 15px 0;
  width: 100%;
  background-color: white;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  .contain {
    padding: 0 100px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    @media screen and (max-width: 900px) {
      padding: 0 50px;
    }
    @media screen and (max-width: 600px) {
      padding: 0 30px;
    }
    .logo {
      height: 50px;
      cursor: pointer;
    }
    .profile-icon {
      height: 40px;
      display: none;
      @media screen and (max-width: 600px) {
        display: block;
      }
    }
    .btns {
      @media screen and (max-width: 600px) {
        display: none;
      }
    }
  }
}

.admin-header {
  padding: 10px 20px;
  background-color: #132628;
  box-shadow: none;
  display: flex;
  justify-content: space-between;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  p {
    margin: 0;
    color: white;
    font-size: 14px;
  }
  .logout {
    color: #49c6d4;
    cursor: pointer;
  }
}

.sidebar {
  position: fixed;
  z-index: 9;
  padding-top: 39px;
  left: 0;
  top: 0;
  width: 250px;
  background: white;
  height: 100%;
  box-shadow: 0 0 8px hsla(0, 0%, 50.2%, 0.35);
  transition: margin 0.5s;
  @media screen and (max-width: 950px) {
    margin-left: -250px;
    &.active {
      margin-left: 0;
    }
  }
  .welcome {
    padding: 30px 20px;
    padding-left: 30px;
    margin: 0;
    span {
      font-size: 25px;
      font-weight: bold;
      font-family: "SFProDisplay", sans-serif;
      display: block;
    }
  }
  .navs {
    display: flex;
    flex-direction: column;
    .nav {
      width: 100%;
      border-left: 10px solid transparent;
      padding: 17px 20px;
      display: flex;
      cursor: pointer;
      border-top: 2px solid #eaeaea;
      flex-wrap: wrap;
      transition: background-color 0.3s;
      &:last-child {
        border-bottom: 2px solid #eaeaea;
      }
      &:hover {
        background-color: rgba(73, 198, 212, 0.15);
      }
      img {
        height: 20px;
        filter: brightness(0.2);
        margin-right: 15px;
      }
      p {
        margin: 0;
        font-family: "SFProDisplay", sans-serif;
        font-size: 17px;
        font-weight: 500;
      }
      &.active {
        background: rgba(73, 198, 212, 0.15);
        border-left: 10px solid #49c6d4;
        p {
          color: #49c6d4;
          font-weight: bold;
        }
        img {
          filter: none;
        }
      }
      .inner-navs {
        margin-top: 10px;
        width: 100%;
        padding-left: 30px;
        p {
          font-size: 16px;
          opacity: 0.7;
          padding: 3px 0;
          margin-bottom: 2px;
          transition: opacity 0.3s;
          cursor: pointer;
          &:hover {
            opacity: 1;
          }
        }
      }
    }
  }
  .delete-btn {
    position: absolute;
    right: 0;
    opacity: 0.5;
  }
}

.mobile-menu-icon {
  display: none;
  position: fixed;
  z-index: 9;
  background: #49c6d4;
  padding: 10px 0;
  left: 0;
  top: 88px;
  width: 30px;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
  cursor: pointer;
  img {
    height: 27px;
    filter: brightness(0) invert(1);
  }
  @media screen and (max-width: 950px) {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.agreement {
  display: none;
}
</style>
